import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { BaseComponent } from 'src/app/framework/components/base.component';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent implements OnInit {

  pageX = window.innerWidth || this.document.documentElement.clientWidth || this.document.body.clientWidth;
  pageY = window.innerHeight || this.document.documentElement.clientHeight || this.document.body.clientHeight;
  mouseX = 0;
  mouseY = 0;
  constructor(@Inject(DOCUMENT) private document: Document) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e) {
    this.mouseY = e.pageY;
    let yAxis = (this.pageY / 2 - this.mouseY) / this.pageY * 300;
    this.mouseX = e.pageX / -this.pageX;
    let xAxis = -this.mouseX * 100 - 100;
    let _ghost = document.querySelectorAll<HTMLElement>('.box__ghost-eyes');
    for (var i = 0; i < _ghost.length; i++) {
      _ghost[i].style.transform = 'translate(' + xAxis + '%,-' + yAxis + '%)';
    }

  }

}
